<template>
  <svg
    width="196"
    height="96"
    viewBox="0 0 196 96"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      class="fill"
      :class="{ isColored }"
      d="M5.28251 95.4649C2.86651 95.4649 0.913634 93.5271 0.913634 91.1395V91.1395V91.1395C0.82903 79.039 3.3439 67.0604 8.28885 55.9943C12.96 44.8396 19.9005 34.7566 28.6749 26.3729C68.0667 -8.79095 127.924 -8.79095 167.32 26.3729C176.095 34.7565 183.036 44.8396 187.711 55.9943C192.657 67.0604 195.172 79.0391 195.086 91.1395V91.1395C195.086 93.5219 193.129 95.4555 190.723 95.4555L5.28251 95.4649Z"
      fill="none"
    />
  </svg>
</template>

<script lang="ts">
import { defineComponent } from "vue";

export default defineComponent({
  name: "RoutineLogoIcon",
  props: {
    isColored: {
      type: Boolean,
      default: false,
    },
  },
});
</script>

<style scoped lang="scss">
@use "./icon.scss";
path.isColored {
  @include themed() {
    fill: t($secondary);
  }
}
</style>
